module.exports = __webpack_public_path__ + "e3af5854b1bdc40682c96b32ef3087d3.svg";